export default {
  methods: {
    hasPrivatePeriods(year) {
      return !!year.periods.find((period) => period.private)
    },

    hasPeriodsWithData(year) {
      return !!year.periods.find((period) => !!period.ledgerId)
    },
  },
}
